import './App.sass';
import './style/index.sass';
import OneSection from "./components/OneSection";
import TwoSection from "./components/TwoSection";
import Bg from "./components/Bg";
import PopUp from "./components/PopUp";
import MobilePopUp from "./components/MobilePopUp";
import { useWindowSize } from '@react-hook/window-size'

function App() {
  const [width, height] = useWindowSize()

  var stopVideos = function () {
    console.log("close")
    var videos = document.querySelectorAll('iframe, video');
    Array.prototype.forEach.call(videos, function (video) {
      if (video.tagName.toLowerCase() === 'video') {
        video.pause();
      } else {
        var src = video.src;
        video.src = src;
      }
    });
  };

  const closePopup = () => {
    document.querySelector('.c_help-popup__video-overlay').classList.remove('c_video-open');
    stopVideos();
  }

  return (
    <>
      {width > 1100 ? (
        <>
          <Bg></Bg>
          <PopUp></PopUp>
          <div className='c_help-popup__video-overlay' onClick={closePopup}>
            <div className='c_video-wrap'>
              <div className='c_video'>
                <iframe className='iframeVideo' width="560" height="315" src="https://www.youtube.com/embed/z4LNqxXMepw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
            </div>
          </div>
          <OneSection></OneSection>
          <TwoSection></TwoSection>
        </>
      ) : (
        <>
          <MobilePopUp></MobilePopUp>
          <Bg></Bg>
        </>
      )}


    </>
  );
}

export default App;
